import React from 'react'
import { Section } from '../../sections'

// The icon SVGs draw their glyph inside an empty 50x50 circle; this viewBox crops to the glyph
const GLYPH_VIEW_BOX = '10 8 31 31'

interface SectionIconProps {
    section: Section
    size?: number
    // antd Menu passes its icon class through here
    className?: string
}

const SectionIcon: React.FC<SectionIconProps> = ({ section, size = 20, className }) => {
    const { Icon } = section
    return <Icon viewBox={GLYPH_VIEW_BOX} width={size} height={size} className={['nav-icon', className].filter(Boolean).join(' ')} aria-hidden focusable={false} />
}

export default SectionIcon
